import { Component } from '@angular/core';
import { Globals, role_slugs } from 'src/app/common/globals';
import { LoginService } from 'src/app/app-login/login.service';
import { CommonService } from 'src/app/common/services/common.service';
import { ProfileService } from 'src/app/app-profile/profile.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  constructor(
    protected globals: Globals,
    private loginService: LoginService,
    private commonService: CommonService,
    private router: Router,
    private profileService: ProfileService
  ) { }

  isTicketCommittee: boolean = false;

  currentRole: { slug: role_slugs; label: string } =
    this.globals.userCurrentRole;

  ngOnInit() {
    setTimeout(function () {
      $('#navbarNav li a[href]').on('click', function (e: any) {
        // e.preventDefault();
        $('.navbar-collapse').removeClass('show');
      });
      $(document).mouseup(function (e: any) {
        const navbar = $('.navbar-collapse');
        const toggler = $('.navbar-toggler');

        if (
          !navbar.is(e.target) &&
          navbar.has(e.target).length === 0 &&
          !toggler.is(e.target) &&
          toggler.has(e.target).length === 0
        ) {
          navbar.removeClass('show');
        }
      });

      $(document).ready(function () {
        $('#popup').hide();
      });
      $('#open').on('click', function () {
        $('#popup').toggle(200);
      });
      $('.submenu.dropdown-menu li').on('click', function () {
        $('#popup').hide(200);
      });
      $(document).mouseup(function (e: { target: any }) {
        var popup = $('#popup');
        if (
          !$('#open').is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length == 0
        ) {
          popup.hide(200);
        }
      });

      $(document).ready(function () {
        $('#popups').hide();
      });
      $('#opens').on('click', function () {
        $('#popups').toggle(200);
      });
      $('.submenu.dropdown-menu li').on('click', function () {
        $('#popups').hide(200);
      });
      $(document).mouseup(function (e: { target: any }) {
        var popup = $('#popups');
        if (
          !$('#opens').is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length == 0
        ) {
          popup.hide(200);
        }
      });

      $(document).ready(function () {
        $('#popupss').hide();
      });
      $('#openss').on('click', function () {
        $('#popupss').toggle(200);
      });
      $('.submenu.dropdown-menu li').on('click', function () {
        $('#popupss').hide(200);
      });
      $(document).mouseup(function (e: { target: any }) {
        var popup = $('#popupss');
        if (
          !$('#openss').is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length == 0
        ) {
          popup.hide(200);
        }
      });
    }, 500);
    // if(this.globals.isAdmin || this.globals.isItAdmin){
    //   this.getUserListForImpersonation();
    // }
  }

  setProfileLink() {
    if (this.globals.authData.is_profile_completed == 0) {
      this.router.navigate(['/profile/required']);
    } else {
      this.router.navigate(['/profile']);
    }
  }

  logout() {
    this.commonService.showLoader();
    this.loginService.logout().then(
      (data: any) => {
        this.stopImpersonation();
        this.router.navigate(['/']);
      },
      (error) => {
        this.commonService.hideLoader();
        this.router.navigate(['/']);
      }
    );
  }

  showCredential() {
    $('.navbar-collapse').removeClass('show');

    if (
      this.globals.authData.directoryInfoValid &&
      this.globals.authData.volunteerInfoValid
    ) {
      window.open(this.globals.authData.certificate_link, '_blank');
    } else {
      Swal.fire({
        title: 'Incomplete Profile',
        text: 'To view your credentials, we request you to complete your profile first!',
        //icon: 'warning',
        confirmButtonText: 'OK',
        showDenyButton: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
        }
      });
    }
  }

  roleToSwitch: { slug: role_slugs; label: string } =
    this.globals.userCurrentRole;
  switchRoleDialog: boolean = false;
  ddUserRoles: { slug: role_slugs; label: string }[] =
    this.globals.authData.roles;

  closeSwitchRoleDialog() {
    this.switchRoleDialog = false;
    this.roleToSwitch = this.globals.userCurrentRole;
  }

  openSwitchRoleDialog() {
    this.switchRoleDialog = true;
  }

  switchRole() {
    this.commonService.setCookie('current_role', this.roleToSwitch);
    this.switchRoleDialog = false;
    this.commonService.showNotification(
      'success',
      `You have switched to the ${this.roleToSwitch.label} role. The page will reload in 2 seconds.`,
      2000
    );
    setTimeout(() => {
      if (this.roleToSwitch.slug === 'candidate') {
        window.location.href = '/';
      } else if (this.roleToSwitch.slug === 'it-admin' || this.roleToSwitch.slug === 'admin') {
        window.location.href = '/my-admin/dashboard';
      } else if (this.roleToSwitch.slug === 'facility') {
        if (this.globals.selectedFacility.role.id == 2) {
          window.location.href = '/facility-store';
        } else {
          window.location.href = '/facility';
        }
      } else {
        window.location.href = '/my-admin';
      }
    }, 2000);
  }

  impersonateDialog: boolean = false;
  impersonateUser: User | null = null;

  userList: User[] = [];
  filteredUserList: User[] = [];
  userListLoading: boolean = false;
  defaultUser: User = {
    id: null,
    cci_id: null,
    netforum_cci_id: null,
    email: null,
    name: 'Enter a CCI ID, name, or email to search.',
  };

  getUserListForImpersonation(searchText: string = '') {
    this.userListLoading = true;
    this.commonService.getUserListForImpersonation(searchText).then(
      (data: any) => {
        //  this.commonService.hideLoader();
        const users = data.data.filter((user: User) => user.id !== this.globals.authData.id);
        this.userList = users;
        this.filteredUserList = users;
        this.userListLoading = false;
      }
    );
  }

  ddFilterUser: (...args: any[]) => void = this.globals.debounce((searchText) => {
    //trim search text
    searchText = searchText.trim();
    if (searchText.length > 2) {
      this.getUserListForImpersonation(searchText);
    } else {
      this.userList = [];
      this.filteredUserList = [];
    }
  }, 500);

  // ddFilterUser(searchText: string) {
  //   this.filteredUserList = this.userList.filter(
  //     (s) =>
  //       (s.name &&
  //         s.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
  //       (s.email &&
  //         s.email.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
  //       (s.cci_id &&
  //         s.cci_id.toLowerCase().indexOf(searchText.toLowerCase()) !== -1)
  //   );
  // }

  showImpersonateDialog() {
    this.impersonateUser = this.defaultUser;
    this.impersonateDialog = true;
  }

  closeImpersonateDialog() {
    this.impersonateDialog = false;
  }

  startImpersonateSession() {
    if (this.impersonateUser && this.impersonateUser.id) {
      this.commonService.showLoader();
      this.commonService.setCookie('impersonate_id', this.impersonateUser.id);
      this.commonService.setCookie('impersonate_by', this.globals.authData.id);
      this.commonService.setCookie('impersonate_by_last_page', this.globals.currentLink);
      this.updateAuthData(this.impersonateUser.id);
    }
  }

  stopImpersonation() {
    this.commonService.showLoader();
    const impersonateBy = this.globals.impersonateBy;
    this.commonService.clearCookie('impersonate_id');
    this.commonService.clearCookie('impersonate_by');
    this.commonService.clearCookie('impersonate_by_last_page');
    if (impersonateBy) {
      this.updateAuthData(impersonateBy, true);
    }
  }

  updateAuthData(userId: string, redirectToLastPage: boolean = false) {
    this.profileService.getAuthUserData(userId).then(
      (data: any) => {
        const userData = this.globals.authData;

        const defaultRole = userData.roles[0];
        this.commonService.setCookie('current_role', defaultRole);

        // Sync state to global
        this.commonService.syncAuthGlobals();

        const roleSlug = defaultRole.slug;

        if (redirectToLastPage) {
          window.location.href = this.globals.impersonateByLastPage || '/';
        } else {
          if (roleSlug === 'candidate') {
            window.location.href = '/';
          } else if (roleSlug === 'it-admin' || roleSlug === 'admin') {
            window.location.href = '/my-admin/dashboard';
          } else if (roleSlug === 'facility') {
            if (this.globals.selectedFacility.role.id == 2) {
              window.location.href = '/facility-store';
            } else {
              window.location.href = '/facility';
            }
          } else {
            window.location.href = '/my-admin';
          }
        }
      },
      (error) => {
        this.commonService.hideLoader();
      }
    );
  }

  isCurrentlyImpersonating(): boolean {
    return !!this.globals.impersonateId;
  }

  headerLogoRouterLink() {
    if (this.globals.isItAdmin || this.globals.isAdmin) {
      return '/my-admin/dashboard';
    } else if (this.currentRole.slug === 'auditor' || this.currentRole.slug === 'accountant') {
      return '/my-admin/audit';
    } else if (this.currentRole.slug === 'credential-manager') {
      return '/my-admin/users';
    } else if (this.currentRole.slug === 'candidate') {
      return '/professional';
    } else if (this.currentRole.slug === 'facility') {
      return '/facility';
    } else {
      return '/';
    }
  }

  openLMS() {
    this.commonService.showLoader();
    this.commonService.getLearnUponSSOUrl().then(
      (data: any) => {
        this.commonService.hideLoader();
        const url = data.data;
        window.open(url, '_blank');
      }
    );
  }
}


export interface User {
  id: string | null;
  cci_id: string | null;
  netforum_cci_id: string | null;
  email: string | null;
  name: string;
}